module.exports = __webpack_public_path__ + "img/bg.a9d2fb03.jpg";